import {CopyToClipboard} from 'react-copy-to-clipboard';
import CopyIcon from '@mui/icons-material/ContentCopy';
import { Button } from '@mui/material';
import { useContext } from 'react';
import ToastContext from '../../../services/Context/ToastContext';

export default function ActionRef({value}){

    const { setToast } = useContext(ToastContext)

    return (
    
        <CopyToClipboard 
            text={value} 
            onCopy={() => setToast({
                severity: 'success', 
                message: "La référence de l'action a bien été copiée !"
            })}
        >
            <Button endIcon={<CopyIcon />}>
                {value}
            </Button>
        </CopyToClipboard>

    )
}